import { MathUtils } from 'three';
import { SingularStationArea, StationaryArea } from '@thive/fddm-types';

import { isSingularStationArea } from '@/modules/floorplanDesign/helpers';

type ConstellationArea = SingularStationArea | StationaryArea;

/** @description Angle of the first load handling POI spec. Only singular station areas have one. */
export const getLoadHandlingAngle = (area: ConstellationArea): number =>
  isSingularStationArea(area) ? area.loadHandlingPoiSpecs[0]?.angle ?? 0 : 0;

/** @description Rotation (degrees) of the spacing icon, following the area's constellation direction. */
export const getSpacingIconRotationDeg = (area: ConstellationArea): number =>
  90 +
  MathUtils.radToDeg(
    -area.rectangle.angle - area.constellationSpec.angle + getLoadHandlingAngle(area),
  );
